import State from '@linc-technologies/linced-common/models/goals/state';
import type { Type } from '@warp-drive/core/types/symbols';
import { belongsTo, type AsyncBelongsTo } from '@warp-drive/legacy/model';
import type Goal from 'linced-admin/models/goals/goal';

// linced-admin replaces goals/goal with its own model, which has no `states`
// relationship, so goalId has no inverse here. linced-common declares
// inverse: 'states' to pair with the shared goals/goal; this override keeps
// that from asserting in this app, and matches the inverse EmberData already
// auto-detects for linced-admin today.
export default class _State extends State {
  declare [Type]: 'goals/state';

  @belongsTo('goals/goal', { async: true, inverse: null })
  // @ts-expect-error the linced-admin goals/goal is goals.GoalTemplate, not the
  // common Goal.
  declare goalId: AsyncBelongsTo<Goal>;
}
